import type { FC, ReactElement } from 'react';

import type { CurrencyFormatterOptions } from '../../formatters/CurrencyFormatter';
import { useHideCurrency } from '../../store/compositeSelectors/useHideCurrency';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { useSettingsSlice } from '../../store/slices/settings/selectors';

import { Currency } from './Currency';

export interface CurrencyConnectedProps extends Omit<CurrencyFormatterOptions, 'currency' | 'locale'> {
  /** The value to be formatted */
  value: number;
}

export const CurrencyConnected: FC<CurrencyConnectedProps> = ({ value, hideCurrency, ...rest }): ReactElement | null => {
  const currency = useGameStateSlice.getCurrency();
  const currentLanguage = useSettingsSlice.currentLanguage();

  const hideCurrencyConfig = useHideCurrency();

  if (!currency) return null;

  return <Currency currency={currency} hideCurrency={hideCurrencyConfig || hideCurrency} locale={currentLanguage} value={value} {...rest} />;
};
